import { render, staticRenderFns } from "./WNotifications.vue?vue&type=template&id=7b9dfcb3&scoped=true&"
import script from "./WNotifications.vue?vue&type=script&lang=js&"
export * from "./WNotifications.vue?vue&type=script&lang=js&"
import style0 from "./WNotifications.vue?vue&type=style&index=0&id=7b9dfcb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9dfcb3",
  null
  
)

export default component.exports